import { Rocket, MessageCircle } from "lucide-react";
import { SITE, waLink } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

export const Licenciado = () => (
  <section className="relative py-24 sm:py-28 bg-[#061A14] overflow-hidden" data-testid="licenciado-section">
    <div className="absolute -bottom-32 right-1/4 w-[480px] h-[480px] rounded-full bg-[#00E676]/8 blur-[130px]" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="rounded-3xl border border-[#00E676]/20 bg-[#0B261E]/60 backdrop-blur-md p-8 sm:p-14 grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <Overline>Para quem quer empreender</Overline>
            <SectionTitle>
              Quer oferecer energia limpa <Accent>como licenciado iGreen</Accent>?
            </SectionTitle>
            <p className="mt-5 max-w-lg text-sm sm:text-base text-emerald-100/60 leading-relaxed">
              Conheça como funciona a licença, o treinamento e o suporte para indicar energia, celular e seguros.
              Eu te explico tudo, sem compromisso.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="/seja-licenciado"
                data-testid="licenciado-info-cta"
                className="inline-flex items-center gap-2 rounded-full bg-[#00E676] hover:bg-[#00C853] text-[#04120E] font-bold px-7 py-4 shadow-[0_0_24px_rgba(0,230,118,0.4)] transition-[background-color,transform] duration-300 hover:scale-[1.03]"
              >
                <Rocket size={17} /> Como funciona a licença
              </a>
              <a
                href={waLink(SITE.whatsappLicenciadoMessage)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="licenciado-talk-cta"
                className="inline-flex items-center gap-2 rounded-full border border-[#00E676]/35 bg-emerald-950/50 text-[#00E676] font-semibold px-7 py-4 hover:bg-emerald-900/60 transition-colors duration-300"
              >
                <MessageCircle size={17} /> Conversar sobre a licença
              </a>
            </div>
          </div>
          <div className="lg:col-span-2 hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 rounded-full bg-[#00E676]/15 blur-2xl" />
              <div className="relative grid place-items-center w-44 h-44 mx-auto rounded-full border border-[#00E676]/30 bg-[#04120E]/80">
                <Rocket size={64} className="text-[#00E676]" />
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
